<kendo-window [resizable]="false" title="title" (close)="_close(true)">
  <div class="row">
    <div class="col-12">
      <div class="customPopupHeader">
        <div class="popupHeaderTitle">{{_title}}</div>
        <ul class="popupBouttons">
          <li>
            @if (!data.model.withoutConfirm && _title!='Duplicate' ) {
              <a (click)="_close(false)"><span><img
              [src]="'/assets/menu/'+ _theme +'/ok-icon.svg'" /></span>Yes</a>
            }
          </li>
          <li>
            @if (!data.model.withoutConfirm && _title!='Duplicate' ) {
              <a (click)="_close(true)"><span><img
              [src]="'/assets/menu/'+ _theme +'/close-icon.svg'" /></span>No</a>
            }
          </li>

          <li>
            @if (!data.model.withoutConfirm && _title=='Duplicate' ) {
              <a (click)="_close(true)"><span><img
              [src]="'/assets/menu/'+ _theme +'/close-icon.svg'" /></span>Close</a>
            }
          </li>
          <li>
            @if (data.model.withoutConfirm) {
              <a (click)="_close(true)"><span><img
              [src]="'/assets/menu/'+ _theme +'/close-icon.svg'" /></span>Ok</a>
            }
          </li>
        </ul>
      </div>
    </div>
    <div class="col-12">
      <div class="bodyPopupContainer">
        <div class="popupBodyImage">
          <img [src]="'/assets/menu/'+ _theme +'/notification-icon.svg'" />
        </div>
        <div class="popupBodyMessage" [innerHTML]="_message "></div>
      </div>
    </div>
    @if (data.model.withNote) {
      <div class="col-12">
        <div class="notePopupContainer">
          <label class="notePopupLabel">Note <span class="notePopupOptional">(optional)</span></label>
          <textarea class="k-textbox writebox notePopupTextarea" rows="3" [(ngModel)]="_note"
            placeholder="Enter a note...">
          </textarea>
        </div>
      </div>
    }
  </div>
</kendo-window>